import { Link, useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { Row, Col, ListGroup, Image, Form, Button, Card } from 'react-bootstrap'
import { FaTrash, FaShoppingBag } from 'react-icons/fa'
import Message from '../../components/Message/Message'
import { addToCart, removeFromCart } from '../../slices/cartSlice'

const Cart = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const cart = useSelector((state) => state.cart)
  const { cartItems } = cart

  const addToCardHandler = async (product, qty) => {
    dispatch(addToCart({ ...product, qty }))
  }

  const removeFromCartHandler = (id) => {
    dispatch(removeFromCart(id))
  }

  const checkOutHandler = () => {
    navigate('/login?redirect=/shipping')
  }

  return (
    <Row className="cart-layout">
      <Col md={8}>
        <div className="section-heading-row">
          <div>
            <p className="section-eyebrow">Your selection</p>
            <h1 className="page-title">Shopping Cart</h1>
          </div>
        </div>
        {cartItems.length === 0 ? (
          <Message>
            Your cart is empty <Link to="/">Explore products</Link>
          </Message>
        ) : (
          <ListGroup variant="flush" className="cart-items">
            {cartItems.map((item) => (
              <ListGroup.Item key={item.product} className="cart-item">
                <Row className="align-items-center g-3">
                  <Col md={2}>
                    <Image src={item.image} alt={item.name} fluid rounded />
                  </Col>
                  <Col md={3} className="cart-item-name">
                    <Link to={`/product/${item._id}`}>{item.name}</Link>
                  </Col>
                  <Col md={2} className="cart-price">${item.price}</Col>
                  <Col md={2}>
                    <Form.Control
                      as="select"
                      value={item.qty}
                      onChange={(e) =>
                        addToCardHandler(item, Number(e.target.value))
                      }
                    >
                      {[...Array(item.countInStock).keys()].map((x) => (
                        <option key={x + 1} value={x + 1}>
                          {x + 1}
                        </option>
                      ))}
                    </Form.Control>
                  </Col>
                  <Col md={2}>
                    <Button
                      type="button"
                      variant="light"
                      className="icon-button danger-icon"
                      onClick={() => removeFromCartHandler(item._id)}
                      aria-label={`Remove ${item.name}`}
                    >
                      <FaTrash />
                    </Button>
                  </Col>
                </Row>
              </ListGroup.Item>
            ))}
          </ListGroup>
        )}
      </Col>
      <Col md={4}>
        <Card className="summary-card">
          <ListGroup variant="flush">
            <ListGroup.Item>
              <div className="summary-icon">
                <FaShoppingBag />
              </div>
              <h2>Order Snapshot</h2>
              <p>
                {cartItems.reduce((acc, item) => acc + item.qty, 0)} items
              </p>
              <strong className="summary-total">
                $
                {cartItems
                  .reduce((acc, item) => acc + item.qty * item.price, 0)
                  .toFixed(2)}
              </strong>
            </ListGroup.Item>
            <ListGroup.Item>
              <Button
                type="button"
                className="btn-block"
                disabled={cartItems.length === 0}
                onClick={checkOutHandler}
              >
                Proceed To Checkout
              </Button>
            </ListGroup.Item>
          </ListGroup>
        </Card>
      </Col>
    </Row>
  )
}

export default Cart
